import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';

const MagicShowsOrlandoPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  // Schema markup for SEO
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Event",
        "@id": "https://www.simonnomislive.com/magic-shows-orlando#event",
        "name": "Mental Hop Scotch - Live Magic Show in Orlando",
        "description": "A high-octane, 90-minute mental magic experience where the stage is the entire audience. Performed by master illusionist Simon Nomis in Orlando, FL.",
        "image": "https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/nyl6m05g_mental2.jpg",
        "url": "https://www.simonnomislive.com/magic-shows-orlando",
        "eventStatus": "https://schema.org/EventScheduled",
        "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
        "startDate": "2026-03-14T19:00:00-05:00",
        "endDate": "2026-03-14T20:45:00-05:00",
        "performer": {
          "@type": "Person",
          "name": "Simon Nomis",
          "jobTitle": "Master Magician, Illusionist, and Mentalist",
          "sameAs": ["https://www.instagram.com/SIMONNOMISMAGIC"]
        },
        "location": {
          "@type": "Place",
          "name": "Orlando, FL",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Orlando",
            "addressRegion": "FL",
            "addressCountry": "US"
          }
        },
        "offers": [
          {
            "@type": "Offer",
            "name": "VIP Experience",
            "price": "70",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": "https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch",
            "validFrom": "2026-01-01"
          },
          {
            "@type": "Offer",
            "name": "Premium Experience",
            "price": "50",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": "https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch",
            "validFrom": "2026-01-01"
          },
          {
            "@type": "Offer",
            "name": "Standard Experience",
            "price": "35",
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": "https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch",
            "validFrom": "2026-01-01"
          }
        ],
        "organizer": {
          "@type": "Organization",
          "name": "Simon Nomis Live",
          "url": "https://www.simonnomislive.com"
        }
      },
      {
        "@type": "LocalBusiness",
        "@id": "https://www.simonnomislive.com/magic-shows-orlando#business",
        "name": "Simon Nomis Live - Magic Shows Orlando",
        "description": "Orlando's premier live magic entertainment featuring master illusionist Simon Nomis performing Mental Hop Scotch.",
        "image": "https://customer-assets.emergentagent.com/job_reality-bender/artifacts/es2mwale_logo1.png",
        "url": "https://www.simonnomislive.com/magic-shows-orlando",
        "telephone": "+1-407-442-1933",
        "email": "simon@simonnomismagic.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Orlando",
          "addressRegion": "FL",
          "addressCountry": "US"
        },
        "priceRange": "$35-$70",
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "19:00",
          "closes": "21:00"
        }
      },
      {
        "@type": "FAQPage",
        "@id": "https://www.simonnomislive.com/magic-shows-orlando#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What is Mental Hop Scotch?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Mental Hop Scotch is a high-octane, 90-minute mental magic experience where the stage is the entire audience and the line between reality and the impossible is completely erased. Performed by the master of psychological illusion, Simon Nomis, this isn't a show you watch—it's a game you play."
            }
          },
          {
            "@type": "Question",
            "name": "Is the show family-friendly?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Mental Hop Scotch is not recommended for children under 12. The show contains complex psychological themes and interactive elements that are best suited for mature audiences."
            }
          },
          {
            "@type": "Question",
            "name": "How long is the show?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "The show runs for approximately 90 minutes with a 15-minute intermission."
            }
          },
          {
            "@type": "Question",
            "name": "Where is the show located?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Mental Hop Scotch is performed in Orlando, FL. Visit simonnomislive.com for the latest venue details."
            }
          },
          {
            "@type": "Question",
            "name": "When are the show times?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Shows are held every Saturday at 7:00 PM."
            }
          },
          {
            "@type": "Question",
            "name": "How do I purchase tickets?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Tickets can be purchased online through our secure ticketing partner. We offer three ticket tiers: VIP Experience ($70), Premium Experience ($50), and Standard Experience ($35)."
            }
          }
        ]
      }
    ]
  };

  const faqs = [
    {
      question: "What is Mental Hop Scotch?",
      answer: "Mental Hop Scotch is a high-octane, 90-minute mental magic experience where the stage is the entire audience and the line between reality and the impossible is completely erased. Performed by the master of psychological illusion, Simon Nomis, this isn't a show you watch—it's a game you play."
    },
    {
      question: "Is the show family-friendly?",
      answer: "Mental Hop Scotch is not recommended for children under 12. The show contains complex psychological themes and interactive elements that are best suited for mature audiences who can fully appreciate the mental magic experience."
    },
    {
      question: "How long is the show?",
      answer: "The show runs for approximately 90 minutes with a 15-minute intermission. We recommend arriving at least 30 minutes before showtime to get settled and enjoy the pre-show atmosphere."
    },
    {
      question: "Where is the show located?",
      answer: "Mental Hop Scotch is performed in Orlando, FL. Visit simonnomislive.com for the latest venue and location details."
    },
    {
      question: "When are the show times?",
      answer: "Shows are held every Saturday at 7:00 PM. We recommend booking in advance as shows frequently sell out due to the intimate venue size."
    },
    {
      question: "How do I purchase tickets?",
      answer: "Tickets can be purchased online through our secure ticketing partner. Simply click the 'Buy Tickets Now' button on this page or visit our tickets section. We offer three ticket tiers: VIP Experience ($70), Premium Experience ($50), and Standard Experience ($35)."
    },
    {
      question: "What's included with VIP tickets?",
      answer: "VIP Experience tickets ($70) include front row premium seating (Rows 1-2), an exclusive Simon Nomis t-shirt, VIP pre-show meet & greet, personal photo with Simon, and signed program and magic props."
    },
    {
      question: "Is photography allowed during the show?",
      answer: "No photography or video recording is permitted during the performance to preserve the magic and ensure the best experience for all guests. However, there will be designated photo opportunities before and after the show."
    },
    {
      question: "What should I expect during the show?",
      answer: "Expect to be amazed! Simon leaps from mind to mind in a breathtaking display of mental agility. He doesn't just guess thoughts; he plucks them from the air, influences choices, and reveals information that simply couldn't be known. Audience members become the stars of the show and may even walk away with cash won in impossible predictions or actual props as souvenirs."
    },
    {
      question: "Is there parking available?",
      answer: "Yes, convenient parking is available for all guests. We recommend arriving early to secure parking and allow time to find your seats before the show begins."
    },
    {
      question: "Can I get a refund if I can't attend?",
      answer: "Please review our ticketing partner's refund policy at the time of purchase. We recommend purchasing ticket insurance if your plans may change. For questions about specific bookings, please contact us at simon@simonnomismagic.com."
    },
    {
      question: "Who is Simon Nomis?",
      answer: "Simon Nomis is a master magician, illusionist, and mentalist with over two decades of experience. He has a unique gift for making every audience member feel special, transforming them from passive spectators into co-stars of the show. In 2026, Simon presents two spectacular shows in Orlando: Mental Hop Scotch (playing now) and Obscuring Reality (coming July 2026)."
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Magic Shows in Orlando | Mental Hop Scotch | Simon Nomis Live</title>
        <meta name="description" content="Experience Orlando's best magic show! Mental Hop Scotch is a 90-minute mental magic experience. Book tickets now for Simon Nomis Live - Saturdays at 7PM." />
        <meta name="keywords" content="magic shows Orlando, Orlando magic show, Mental Hop Scotch, Simon Nomis, live magic Orlando, illusionist Orlando, mentalist Orlando, Orlando entertainment, things to do Orlando" />
        <link rel="canonical" href="https://www.simonnomislive.com/magic-shows-orlando" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Magic Shows in Orlando | Mental Hop Scotch | Simon Nomis Live" />
        <meta property="og:description" content="Experience Orlando's best magic show! Mental Hop Scotch is a 90-minute mental magic experience. Book tickets now!" />
        <meta property="og:url" content="https://www.simonnomislive.com/magic-shows-orlando" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/nyl6m05g_mental2.jpg" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Magic Shows in Orlando | Mental Hop Scotch" />
        <meta name="twitter:description" content="Experience Orlando's best magic show! Mental Hop Scotch. Book tickets now!" />
        <meta name="twitter:image" content="https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/nyl6m05g_mental2.jpg" />
        
        {/* Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-black via-purple-900/30 to-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              <span className="text-purple-400">Magic Shows</span> in Orlando
            </h1>
            <p className="text-xl md:text-2xl text-purple-300 mb-8">
              Experience Orlando's Premier Live Magic Entertainment
            </p>
            <p className="text-lg text-gray-300 mb-10 leading-relaxed">
              Looking for the best magic show in Orlando? Discover <strong className="text-purple-400">Mental Hop Scotch</strong> — a mind-bending mental magic experience that will leave you questioning the very nature of reality. Performed by master illusionist Simon Nomis in Orlando, FL.
            </p>
            <a
              href="https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch"
              target="_blank"
              rel="noreferrer"
              className="inline-block font-bold text-xl text-white rounded-full px-10 py-4 transition-all duration-300 hover:scale-105 hover:opacity-90"
              style={{ backgroundColor: 'rgb(181, 36, 189)' }}
            >
              Buy Tickets Now
            </a>
            <div className="mt-5 flex justify-center gap-1">
              <img alt="Visa Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-visa.png" />
              <img alt="Mastercard Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-mc.png" />
              <img alt="Amex Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-amex.png" />
              <img alt="Discover Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-discover.png" />
            </div>
          </div>
        </div>
      </section>

      {/* Show Details Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Image */}
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/nyl6m05g_mental2.jpg"
                  alt="Mental Hop Scotch Magic Show Orlando"
                  className="w-full rounded-lg shadow-2xl"
                />
                <div className="absolute top-4 left-4 transform -rotate-12">
                  <div className="px-4 py-2 border-4 border-green-500 rounded-lg bg-black/50">
                    <span className="text-green-500 text-xl font-bold tracking-wider uppercase">
                      Playing Now
                    </span>
                  </div>
                </div>
              </div>

              {/* Show Info */}
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  <span className="text-purple-400">Mental</span> Hop Scotch
                </h2>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  "Mental Hop Scotch" is a high-octane, 90-minute mental magic experience where the stage is the entire audience and the line between reality and the impossible is completely erased. Performed by the master of psychological illusion, Simon Nomis, this isn't a show you watch—it's a game you play.
                </p>
                <p className="text-gray-300 mb-6 leading-relaxed">
                  In this wildly interactive performance, Simon leaps from mind to mind in a breathtaking display of mental agility. He doesn't just guess thoughts; he plucks them from the air, influences choices, and reveals information that simply couldn't be known.
                </p>
                <p className="text-gray-300 mb-8 leading-relaxed">
                  Audience members walk away with cash won in impossible predictions, actual props used in the show as souvenirs, and a profound sense of amazement that will have them questioning the very nature of their own minds.
                </p>

                {/* Quick Info */}
                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="bg-purple-900/30 p-4 rounded-lg border border-purple-500/30">
                    <div className="text-purple-400 font-bold mb-1">📅 Show Times</div>
                    <div className="text-white">Saturdays at 7:00 PM</div>
                  </div>
                  <div className="bg-purple-900/30 p-4 rounded-lg border border-purple-500/30">
                    <div className="text-purple-400 font-bold mb-1">⏱️ Duration</div>
                    <div className="text-white">90 mins + intermission</div>
                  </div>
                  <div className="bg-purple-900/30 p-4 rounded-lg border border-purple-500/30">
                    <div className="text-purple-400 font-bold mb-1">💵 Tickets From</div>
                    <div className="text-white">$35 - $70</div>
                  </div>
                  <div className="bg-purple-900/30 p-4 rounded-lg border border-purple-500/30">
                    <div className="text-purple-400 font-bold mb-1">👥 Age</div>
                    <div className="text-white">12+ Recommended</div>
                  </div>
                </div>

                <a
                  href="https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-block font-bold text-lg text-white rounded-full px-8 py-3 transition-all duration-300 hover:scale-105"
                  style={{ backgroundColor: 'rgb(181, 36, 189)' }}
                >
                  Get Tickets Now →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Orlando Info Section */}

      {/* Ticket Pricing Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">
              <span className="text-purple-400">Ticket</span> Options
            </h2>
            <div className="grid md:grid-cols-3 gap-6">
              {/* VIP */}
              <div className="bg-gradient-to-b from-yellow-900/30 to-gray-900/30 p-6 rounded-lg border border-yellow-500/30 text-center">
                <div className="w-4 h-4 bg-yellow-600 rounded mx-auto mb-3"></div>
                <h3 className="text-xl font-bold text-yellow-400 mb-2">VIP Experience</h3>
                <div className="text-3xl font-bold text-white mb-4">$70</div>
                <ul className="text-gray-300 text-sm text-left space-y-2 mb-6">
                  <li>✓ Front row seating (Rows 1-2)</li>
                  <li>✓ Exclusive t-shirt</li>
                  <li>✓ Meet & greet with Simon</li>
                  <li>✓ Personal photo</li>
                  <li>✓ Signed program & props</li>
                </ul>
              </div>

              {/* Premium */}
              <div className="bg-gradient-to-b from-blue-900/30 to-gray-900/30 p-6 rounded-lg border border-blue-500/30 text-center">
                <div className="w-4 h-4 bg-blue-600 rounded mx-auto mb-3"></div>
                <h3 className="text-xl font-bold text-blue-400 mb-2">Premium Experience</h3>
                <div className="text-3xl font-bold text-white mb-4">$50</div>
                <ul className="text-gray-300 text-sm text-left space-y-2 mb-6">
                  <li>✓ Premium seating (Rows 3-4)</li>
                  <li>✓ Limited edition poster</li>
                  <li>✓ Priority seating</li>
                  <li>✓ Complimentary program</li>
                </ul>
              </div>

              {/* Standard */}
              <div className="bg-gradient-to-b from-green-900/30 to-gray-900/30 p-6 rounded-lg border border-green-500/30 text-center">
                <div className="w-4 h-4 bg-green-600 rounded mx-auto mb-3"></div>
                <h3 className="text-xl font-bold text-green-400 mb-2">Standard Experience</h3>
                <div className="text-3xl font-bold text-white mb-4">$35</div>
                <ul className="text-gray-300 text-sm text-left space-y-2 mb-6">
                  <li>✓ Reserved seating (Rows 5-10)</li>
                  <li>✓ Full magic show</li>
                  <li>✓ Merchandise store access</li>
                  <li>✓ Complimentary program</li>
                </ul>
              </div>
            </div>

            <div className="text-center mt-10">
              <a
                href="https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch"
                target="_blank"
                rel="noreferrer"
                className="inline-block font-bold text-xl text-white rounded-full px-10 py-4 transition-all duration-300 hover:scale-105"
                style={{ backgroundColor: 'rgb(181, 36, 189)' }}
              >
                Buy Tickets Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-16 bg-gradient-to-br from-black via-purple-900/20 to-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              <span className="text-purple-400">See the</span> Magic
            </h2>
            <p className="text-gray-300 mb-8">
              Watch Simon Nomis in action and get a taste of the incredible experience awaiting you.
            </p>
            <div className="aspect-video rounded-lg overflow-hidden shadow-2xl">
              <video
                src="https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/fthhwe97_Crystal%20Casket.mp4"
                controls
                className="w-full h-full object-cover"
                poster="https://customer-assets.emergentagent.com/job_obscuring-reality/artifacts/nyl6m05g_mental2.jpg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">
              <span className="text-purple-400">Frequently Asked</span> Questions
            </h2>
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div 
                  key={index}
                  className="bg-gray-900/50 rounded-lg border border-purple-500/30 overflow-hidden"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-purple-900/20 transition-colors"
                  >
                    <span className="text-white font-semibold pr-4">{faq.question}</span>
                    <span className="text-purple-400 text-2xl flex-shrink-0">
                      {openFaq === index ? '−' : '+'}
                    </span>
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-4">
                      <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-br from-purple-900/30 via-black to-purple-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Ready to Experience the <span className="text-purple-400">Impossible</span>?
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Don't miss Orlando's most talked-about magic show. Book your tickets today and prepare to have your mind blown!
            </p>
            <a
              href="https://simonnomismagcentertainment.ticketspice.com/mental-hop-scotch"
              target="_blank"
              rel="noreferrer"
              className="inline-block font-bold text-xl text-white rounded-full px-12 py-5 transition-all duration-300 hover:scale-105 hover:opacity-90"
              style={{ backgroundColor: 'rgb(181, 36, 189)' }}
            >
              Buy Tickets Now
            </a>
            <div className="mt-5 flex justify-center gap-1">
              <img alt="Visa Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-visa.png" />
              <img alt="Mastercard Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-mc.png" />
              <img alt="Amex Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-amex.png" />
              <img alt="Discover Logo" width="40" src="https://s3-us-west-2.amazonaws.com/assets.webconnex.com/images/cc-logos/cc-logo-discover.png" />
            </div>
            <p className="text-gray-400 mt-6 text-sm">
              📍 Orlando, FL | Saturdays at 7PM
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MagicShowsOrlandoPage;
